import styled from '@emotion/styled/macro'
import { Flex } from '@rebass/grid/emotion'
import { useSessionStorage } from 'hooks/useSessionStorage'
import { isEmpty } from 'lodash-es'
import { themeColor } from 'mixins'
import { INavLink, INavProps } from 'office-ui-fabric-react'
import * as React from 'react'
import { AppNavigationBottomNav, AppNavigationNav } from './AppNavigationNavs'

const AppNavigationPane = styled(Flex)`
  background: ${themeColor('neutralPrimary')};
  border-right: 1px solid ${themeColor('neutralLighter')};
  overflow-y: scroll;
`

export interface AppNavigationProps {
  navProps?: INavProps
  areaNavProps?: INavProps
  className?: string
}
type areaKey = 'admin' | 'app'
type linkStateStorageType = Record<areaKey, Record<string, INavLink>>

export const AppNavigation: React.FunctionComponent<AppNavigationProps> = ({
  navProps,
  areaNavProps,
  className,
}) => {
  const [persistNav, setPersistNav] = useSessionStorage<linkStateStorageType>(
    'EMOS_navbar_expandedState',
    { app: {}, admin: {} }
  )
  const expandHandler = (ev: any, link?: INavLink) => {
    if (link && link.key && areaNavProps && areaNavProps.selectedKey) {
      const isExpanded = !link.isExpanded
      const areaLinks =
        areaNavProps.selectedKey === 'admin' ? persistNav.admin : persistNav.app
      areaLinks[link.key] = { ...link, isExpanded } as INavLink
      setPersistNav(persistNav)
    }
  }

  const groupCreater = () => {
    // if (
    //   !navProps ||
    //   !navProps.groups ||
    //   navProps.groups.length === 0 ||
    //   !areaNavProps ||
    //   !areaNavProps.selectedKey
    // ) {
    //   return [] as INavLinkGroup[]
    // }
    const linksArray =
      navProps &&
      navProps.groups &&
      navProps.groups[0] &&
      navProps.groups[0].links
        ? navProps.groups[0].links
        : []
    const area =
      areaNavProps && areaNavProps.selectedKey ? areaNavProps.selectedKey : []
    const cachedLinksMap = area === 'app' ? persistNav.app : persistNav.admin
    if (!isEmpty(cachedLinksMap)) {
      linksArray.forEach((link, linkIndex) => {
        const cachedValue = cachedLinksMap[link.key!]
        if (cachedValue) {
          linksArray[linkIndex] = cachedValue
        }
      })
    }

    return navProps ? navProps.groups : []
  }
  return (
    <>
      <AppNavigationPane
        flex="1"
        flexDirection="column"
        justifyContent="space-between"
        className={className}
      >
        <AppNavigationNav
          {...navProps}
          onLinkExpandClick={expandHandler}
          groups={groupCreater()}
          styles={{
            ...(navProps ? navProps.styles : {}),
            groupContent: { animation: 'none' },
          }}
        />
      </AppNavigationPane>
      {areaNavProps && (
        <AppNavigationBottomNav
          {...areaNavProps}
          styles={{
            ...areaNavProps.styles,
            groupContent: { marginBottom: 0, animation: 'none' },
            root: { bottom: 0 },
          }}
        />
      )}
    </>
  )
}

export default AppNavigation
